import { FC } from "react"

// utils
import { LANG_CODES_TO_TLD } from "../../utils/general_utils"

const substringAppearsTwice = (string: string, substring: string) => {
  const firstIndex = string.indexOf(substring)
  if (firstIndex === -1) return false // Not found at all

  const secondIndex = string.indexOf(substring, firstIndex + 1)
  return secondIndex !== -1 // Found a second occurrence
}

const isValidUrl = (urlString: string) => {
  try {
    if (
      substringAppearsTwice(urlString, "https://") ||
      substringAppearsTwice(urlString, "http://")
    ) {
      return false
    }

    new URL(urlString)

    return true
  } catch (_) {
    return false
  }
}

export const CanonicalTag: FC<{
  /**
   * must be an absolute url
   */
  href: string
  nodeLocale: string
  shouldNoIndex: boolean
}> = ({ href, nodeLocale, shouldNoIndex }) => {
  if (process.env.GATSBY_DEBUG === "true") {
    console.log("DEBUG: ", {
      href,
      nodeLocale,
      shouldNoIndex,
      LANG_CODES_TO_TLD
    })
  }

  const pathPrefix = process.env.GATSBY_PATH_PREFIX_VALUE || ""
  let finalHref = `${href
    ?.toLowerCase()
    // example: replace '/es' with '/help/es'
    ?.replace(
      `/${nodeLocale?.toLowerCase()}`,
      `/${pathPrefix}/${nodeLocale?.toLowerCase()}`
    )
    ?.replace(`/${pathPrefix}/${pathPrefix}`, `/${pathPrefix}`)
    // replace any two or more consecutive slashes with a single slash
    ?.replace(/\/{2,}/g, "/")
    ?.replace(
      /(http:\/\/|http:\/|http:|https:\/\/|https:\/|https:)/g,
      "https://"
    )}`

  if (!href || !nodeLocale || finalHref?.includes("[slug]") || shouldNoIndex) {
    return null
  }

  // handle a case where a relative url is being used instead of an absolute url
  if (finalHref.startsWith("/")) {
    for (const [langCode, tld] of Object.entries(LANG_CODES_TO_TLD)) {
      const langCodeValueMatches = href.includes(`/${langCode}/`)

      if (langCodeValueMatches) {
        finalHref = `https://eventbrite${tld}` + finalHref
      }
    }
  } else {
    for (const [langCode, tld] of Object.entries(LANG_CODES_TO_TLD)) {
      const langCodeValueMatches = href.includes(`/${langCode}/`)

      if (langCodeValueMatches) {
        finalHref = finalHref?.toLowerCase()?.replace(".com", tld)
      }
    }
  }

  if (!isValidUrl(finalHref)) {
    if (href.startsWith("/") && process.env.GATSBY_PRODUCT_SITE_URL) {
      finalHref = process.env.GATSBY_PRODUCT_SITE_URL + href
    }
  }

  return <link id="canonicalTag" rel="canonical" href={finalHref} />
}
